import '~/pages/projects/issues/index/index';
import Tracking from '~/tracking';

document.addEventListener('DOMContentLoaded', () => {
  new Tracking().bind();
});
